
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import {
	OverrideType,
	FieldOverride,
	FieldOverrideLabels,
	SectionOverride,
	SectionOverrideLabels
} from "@/types/inheritanceOverrides"

@Component({})
export default class TemplateInheritanceOverridePicker extends Vue {
	/* --- Props --- */

	@Prop({ type: Array, default: () => [] })
	value!: Array<FieldOverride | SectionOverride>

	@Prop({ type: String, required: true })
	id!: string

	@Prop({ type: Number, required: true })
	type!: OverrideType

	/* --- Data --- */

	private localValue: Array<FieldOverride | SectionOverride> = []

	/* --- Watchers --- */

	@Watch("value", { immediate: true })
	private onValueChanged (val: Array<FieldOverride | SectionOverride>) {
		this.localValue = Array.isArray(val) ? [...val] : []
	}

	/* --- Computed properties --- */

	private get overrideLabels (): { text: string; value: SectionOverride | FieldOverride }[] {
		switch (this.type) {
			case OverrideType.Field:
				return FieldOverrideLabels.map(o => ({
					text: o.label,
					value: o.key
				}))
			case OverrideType.Section:
				return SectionOverrideLabels.map(o => ({
					text: o.label,
					value: o.key
				}))
			default:
				return []
		}
	}

	/* --- Methods --- */

	private onBack () {
		this.$emit("back")
	}

	private onClear () {
		this.localValue = []
		this.$emit("clear", this.localValue)
	}

	private onInput (val: Array<FieldOverride | SectionOverride>) {
		this.localValue = Array.isArray(val) ? [...val] : []
		this.$emit("input", this.localValue)
	}
}
